exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active_border{cursor:pointer;border:2px solid #4466f2!important}", ""]);

// exports
